// extracted by mini-css-extract-plugin
export var base = "_44-0";
export var updateBanner = "_44-1";